var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Manage Client Databases")]),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_c('client-database-table',{attrs:{"table-items":_vm.clientDatabaseList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }